import React from 'react';

import { GeneralModal } from "components";

import { func_validation } from "functions";

import "assets/scss/components/modals/displayModal.scss";



export function DisplayModal(props) {
    // Props
    const { 
        className,
        headerClassName,

        isModalVisible,

        bodyHeader,
        description,
        input,

        cancelButtonText,

        isWarning
    } = props;

    // Validate Props
    let bodyHeader_validated = func_validation.isNotNullUndefined(bodyHeader)? bodyHeader: "";
    let description_validated = func_validation.isStringTrimNotEmpty(description)? description: "";
    let input_validated = func_validation.isNotNullUndefined(input)? input: "";
    let cancelButtonText_validated = func_validation.isStringTrimNotEmpty(cancelButtonText)? cancelButtonText: "";

    return (
        <GeneralModal
            modalWapperClassName={"component-confirmationModal " +
                (className? className + " ":"")}
            isModalVisible={isModalVisible}
            updateParentState={props.updateParentState}

            // Header

            headerClassName={"component-confirmationModal-header " +
                (headerClassName? headerClassName + " ":"")}
            headerCloseClassName={"component-confirmationModal-header-close"}
            isCloseIconInverse


            // Body

            bodyClassName={"component-confirmationModal-body"}
            bodyWrapperClassName={"component-confirmationModal-bodyWrapper"}

            bodyHeaderClassName={"component-confirmationModal-bodyHeader"}
            bodyHeader={bodyHeader_validated}

            contentClassName={"component-confirmationModal-description"}
            content={description_validated}

            bodyFooterClassName={"component-confirmationModal-input"}
            bodyFooter={input_validated}


            // Footer
            footerClassName={"component-confirmationModal-footer"}
            footerCancelWrapperClassName={"component-confirmationModal-footer-cancelWrapper"}
            footerCancelClassName={"component-confirmationModal-footer-cancel"}
            cancelButtonText={cancelButtonText_validated}
            handleOnCancel={props.handleOnCancel}
            isCancelButtonVisible
        />
    )
}